import {TOKEN} from '../actions';
import '../global';

export default (state = getToken(), action) => {
	switch (action.type) {
		case TOKEN:
			return action.payload;
	}
	return state;
}